// extracted by mini-css-extract-plugin
export default {"cover_card":"Carousel_cover_card__y0fVO","cover_caption":"Carousel_cover_caption__AhJKy","cover_thumb":"Carousel_cover_thumb__-PtKP","mobile_drag":"Carousel_mobile_drag__9DSzd"};